module.exports = __webpack_public_path__ + "img/desc.a294e606.png";